export const PAGINATED_NEWS_QUERY = `
  query paginatedNews($skip: Int = 0, $first: Int = 30) {
    total: newsConnection {
      aggregate {
        count
      }
    },
    news: news(orderBy: published_DESC, skip: $skip, first: $first) {
      id,
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          handle
        }
        imageAlt
      }
    }
  }
`;

export const NEWS_QUERY = `
  query singleNews($id: ID!, $metaPreviewWidth: Int = 1200 , $metaPreviewHeight: Int = 960) {
    new(where: { id: $id }) {
      id
      category
      updatedAt
      createdAt
      published
      title
      alternateTitle
      imageBlock {
        image {
          handle
          url
          height
          width
        }
        imageAlt
      }
      metaPreview: imageBlock {
        image {
          url(
            transformation: {
              image: {
                resize: {
                   width: $metaPreviewWidth,
                   height: $metaPreviewHeight,
                   fit: crop
                }
              }
              document: {
                output: { format: jpg }
              }
            }
          )
        }
      }
      abstract
      introduction
      seo {
        title
        description
        keywords
      }
      mainColumn {
        __typename
        ... on AdvFluid {
          id
          advFluidType
          variant
        }
        ... on ArticleBlock {
          id
          title
          alternativeTitle
          content
        }
        ... on SavingCalculator {
          id
          savingCalculatorType
          title
          description
          priceLabel
          claim
          cta
        }
        ... on EvaluationLeadWizard {
          id
          title
          description
        }
      }
      blocks {
        title
        content
      }
      localities {
        name
        slug
      }
      rightColumn {
        __typename
        ... on AdvFluid {
          advFluidType
          variant
        }
      }
    }
  }
`;

export const RELATED_NEWS_QUERY = `
  query relatedNews($skipId: ID, $date:Date, $createdAt: DateTime, $count: Int = 4) {
    older: news(first: $count, where: { id_not: $skipId, published_lte: $date, createdAt_lt: $createdAt }, orderBy: published_DESC) {
      id,
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          url(
            transformation: {
              image: { resize: { width: 90, height: 60 } }
              document: { output: { format: jpg } }
            }
          )
          handle
        }
        imageAlt
      }
    }
    newer: news(first: $count, where: { id_not: $skipId, published_gte: $date, createdAt_gt: $createdAt}  , orderBy: published_ASC) {
      id,
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          url(
            transformation: {
              image: { resize: { width: 90, height: 60, fit: crop } }
              document: { output: { format: jpg } }
            }
          )
          handle
        }
        imageAlt
      }
    }
  }
`;

export const RELATED_NEWS_BY_LOCALITY_QUERY = `
  query relatedNewsByLocality($locality: String!, $skipId: ID, $first: Int = 4) {
    news(orderBy: published_DESC, where: {localities_some: {slug: $locality}, id_not: $skipId}, first: $first) {
      id
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          handle
        }
        imageAlt
      }
    }
  }
`;
